// source: v1/login_types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v1_access_control_types_pb = require('../v1/access_control_types_pb.js');
goog.object.extend(proto, v1_access_control_types_pb);
var v1_customer_types_pb = require('../v1/customer_types_pb.js');
goog.object.extend(proto, v1_customer_types_pb);
goog.exportSymbol('proto.V1.AuthenticationMethods', null, global);
goog.exportSymbol('proto.V1.BatchSendInviteDto', null, global);
goog.exportSymbol('proto.V1.CreateLoginDto', null, global);
goog.exportSymbol('proto.V1.LoginActivationStatus', null, global);
goog.exportSymbol('proto.V1.LoginDto', null, global);
goog.exportSymbol('proto.V1.LoginStatus', null, global);
goog.exportSymbol('proto.V1.NullableString', null, global);
goog.exportSymbol('proto.V1.NullableString.KindCase', null, global);
goog.exportSymbol('proto.V1.SendInviteDto', null, global);
goog.exportSymbol('proto.V1.SetRolesDto', null, global);
goog.exportSymbol('proto.V1.StatusCodeDto', null, global);
goog.exportSymbol('proto.V1.UpdateLoginDto', null, global);
goog.exportSymbol('proto.V1.UpdateProfileDto', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.LoginDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.LoginDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.LoginDto.displayName = 'proto.V1.LoginDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.CreateLoginDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.V1.CreateLoginDto.repeatedFields_, null);
};
goog.inherits(proto.V1.CreateLoginDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.CreateLoginDto.displayName = 'proto.V1.CreateLoginDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.UpdateLoginDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.UpdateLoginDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.UpdateLoginDto.displayName = 'proto.V1.UpdateLoginDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.UpdateProfileDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.UpdateProfileDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.UpdateProfileDto.displayName = 'proto.V1.UpdateProfileDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.SetRolesDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.V1.SetRolesDto.repeatedFields_, null);
};
goog.inherits(proto.V1.SetRolesDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.SetRolesDto.displayName = 'proto.V1.SetRolesDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.SendInviteDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.SendInviteDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.SendInviteDto.displayName = 'proto.V1.SendInviteDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.BatchSendInviteDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.V1.BatchSendInviteDto.repeatedFields_, null);
};
goog.inherits(proto.V1.BatchSendInviteDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.BatchSendInviteDto.displayName = 'proto.V1.BatchSendInviteDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.StatusCodeDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.StatusCodeDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.StatusCodeDto.displayName = 'proto.V1.StatusCodeDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.NullableString = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.V1.NullableString.oneofGroups_);
};
goog.inherits(proto.V1.NullableString, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.NullableString.displayName = 'proto.V1.NullableString';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.LoginDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.LoginDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.LoginDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.LoginDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    profilePictureUrl: (f = msg.getProfilePictureUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    authenticationMethods: jspb.Message.getFieldWithDefault(msg, 7, 0),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    accesscontrolMap: (f = msg.getAccesscontrolMap()) ? f.toObject(includeInstance, proto.V1.AccessControlDto.toObject) : [],
    customer: (f = msg.getCustomer()) && v1_customer_types_pb.CustomerDto.toObject(includeInstance, f),
    activationstatus: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.LoginDto}
 */
proto.V1.LoginDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.LoginDto;
  return proto.V1.LoginDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.LoginDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.LoginDto}
 */
proto.V1.LoginDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfilePictureUrl(value);
      break;
    case 6:
      var value = /** @type {!proto.V1.LoginStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.V1.AuthenticationMethods} */ (reader.readEnum());
      msg.setAuthenticationMethods(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = msg.getAccesscontrolMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.V1.AccessControlDto.deserializeBinaryFromReader, "", new proto.V1.AccessControlDto());
         });
      break;
    case 11:
      var value = new v1_customer_types_pb.CustomerDto;
      reader.readMessage(value,v1_customer_types_pb.CustomerDto.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 12:
      var value = /** @type {!proto.V1.LoginActivationStatus} */ (reader.readEnum());
      msg.setActivationstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.LoginDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.LoginDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.LoginDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.LoginDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProfilePictureUrl();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAuthenticationMethods();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccesscontrolMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.V1.AccessControlDto.serializeBinaryToWriter);
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      v1_customer_types_pb.CustomerDto.serializeBinaryToWriter
    );
  }
  f = message.getActivationstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.V1.LoginDto.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.V1.LoginDto.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.V1.LoginDto.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.V1.LoginDto.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue profile_picture_url = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.LoginDto.prototype.getProfilePictureUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.LoginDto} returns this
*/
proto.V1.LoginDto.prototype.setProfilePictureUrl = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.clearProfilePictureUrl = function() {
  return this.setProfilePictureUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.LoginDto.prototype.hasProfilePictureUrl = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional LoginStatus status = 6;
 * @return {!proto.V1.LoginStatus}
 */
proto.V1.LoginDto.prototype.getStatus = function() {
  return /** @type {!proto.V1.LoginStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.V1.LoginStatus} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional AuthenticationMethods authentication_methods = 7;
 * @return {!proto.V1.AuthenticationMethods}
 */
proto.V1.LoginDto.prototype.getAuthenticationMethods = function() {
  return /** @type {!proto.V1.AuthenticationMethods} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.V1.AuthenticationMethods} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setAuthenticationMethods = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.V1.LoginDto.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.V1.LoginDto} returns this
*/
proto.V1.LoginDto.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.LoginDto.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.V1.LoginDto.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.V1.LoginDto} returns this
*/
proto.V1.LoginDto.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.LoginDto.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * map<string, AccessControlDto> accessControl = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.V1.AccessControlDto>}
 */
proto.V1.LoginDto.prototype.getAccesscontrolMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.V1.AccessControlDto>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      proto.V1.AccessControlDto));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.clearAccesscontrolMap = function() {
  this.getAccesscontrolMap().clear();
  return this;};


/**
 * optional CustomerDto customer = 11;
 * @return {?proto.V1.CustomerDto}
 */
proto.V1.LoginDto.prototype.getCustomer = function() {
  return /** @type{?proto.V1.CustomerDto} */ (
    jspb.Message.getWrapperField(this, v1_customer_types_pb.CustomerDto, 11));
};


/**
 * @param {?proto.V1.CustomerDto|undefined} value
 * @return {!proto.V1.LoginDto} returns this
*/
proto.V1.LoginDto.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.LoginDto.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional LoginActivationStatus activationStatus = 12;
 * @return {!proto.V1.LoginActivationStatus}
 */
proto.V1.LoginDto.prototype.getActivationstatus = function() {
  return /** @type {!proto.V1.LoginActivationStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.V1.LoginActivationStatus} value
 * @return {!proto.V1.LoginDto} returns this
 */
proto.V1.LoginDto.prototype.setActivationstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.V1.CreateLoginDto.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.CreateLoginDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.CreateLoginDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.CreateLoginDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.CreateLoginDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = msg.getPassword()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    profilePictureUrl: (f = msg.getProfilePictureUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.CreateLoginDto}
 */
proto.V1.CreateLoginDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.CreateLoginDto;
  return proto.V1.CreateLoginDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.CreateLoginDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.CreateLoginDto}
 */
proto.V1.CreateLoginDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfilePictureUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.CreateLoginDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.CreateLoginDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.CreateLoginDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.CreateLoginDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassword();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProfilePictureUrl();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue password = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.CreateLoginDto.prototype.getPassword = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.CreateLoginDto} returns this
*/
proto.V1.CreateLoginDto.prototype.setPassword = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.clearPassword = function() {
  return this.setPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.CreateLoginDto.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.V1.CreateLoginDto.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.V1.CreateLoginDto.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.V1.CreateLoginDto.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue profile_picture_url = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.CreateLoginDto.prototype.getProfilePictureUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.CreateLoginDto} returns this
*/
proto.V1.CreateLoginDto.prototype.setProfilePictureUrl = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.clearProfilePictureUrl = function() {
  return this.setProfilePictureUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.CreateLoginDto.prototype.hasProfilePictureUrl = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string roles = 6;
 * @return {!Array<string>}
 */
proto.V1.CreateLoginDto.prototype.getRolesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.V1.CreateLoginDto} returns this
 */
proto.V1.CreateLoginDto.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.UpdateLoginDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.UpdateLoginDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.UpdateLoginDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.UpdateLoginDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    profileUpdate: (f = msg.getProfileUpdate()) && proto.V1.UpdateProfileDto.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.UpdateLoginDto}
 */
proto.V1.UpdateLoginDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.UpdateLoginDto;
  return proto.V1.UpdateLoginDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.UpdateLoginDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.UpdateLoginDto}
 */
proto.V1.UpdateLoginDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginId(value);
      break;
    case 2:
      var value = new proto.V1.UpdateProfileDto;
      reader.readMessage(value,proto.V1.UpdateProfileDto.deserializeBinaryFromReader);
      msg.setProfileUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.UpdateLoginDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.UpdateLoginDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.UpdateLoginDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.UpdateLoginDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProfileUpdate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.V1.UpdateProfileDto.serializeBinaryToWriter
    );
  }
};


/**
 * optional string login_id = 1;
 * @return {string}
 */
proto.V1.UpdateLoginDto.prototype.getLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.UpdateLoginDto} returns this
 */
proto.V1.UpdateLoginDto.prototype.setLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UpdateProfileDto profile_update = 2;
 * @return {?proto.V1.UpdateProfileDto}
 */
proto.V1.UpdateLoginDto.prototype.getProfileUpdate = function() {
  return /** @type{?proto.V1.UpdateProfileDto} */ (
    jspb.Message.getWrapperField(this, proto.V1.UpdateProfileDto, 2));
};


/**
 * @param {?proto.V1.UpdateProfileDto|undefined} value
 * @return {!proto.V1.UpdateLoginDto} returns this
*/
proto.V1.UpdateLoginDto.prototype.setProfileUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.UpdateLoginDto} returns this
 */
proto.V1.UpdateLoginDto.prototype.clearProfileUpdate = function() {
  return this.setProfileUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.UpdateLoginDto.prototype.hasProfileUpdate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.UpdateProfileDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.UpdateProfileDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.UpdateProfileDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.UpdateProfileDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = msg.getEmail()) && proto.V1.NullableString.toObject(includeInstance, f),
    firstName: (f = msg.getFirstName()) && proto.V1.NullableString.toObject(includeInstance, f),
    lastName: (f = msg.getLastName()) && proto.V1.NullableString.toObject(includeInstance, f),
    profilePictureUrl: (f = msg.getProfilePictureUrl()) && proto.V1.NullableString.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.UpdateProfileDto}
 */
proto.V1.UpdateProfileDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.UpdateProfileDto;
  return proto.V1.UpdateProfileDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.UpdateProfileDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.UpdateProfileDto}
 */
proto.V1.UpdateProfileDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.V1.NullableString;
      reader.readMessage(value,proto.V1.NullableString.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 2:
      var value = new proto.V1.NullableString;
      reader.readMessage(value,proto.V1.NullableString.deserializeBinaryFromReader);
      msg.setFirstName(value);
      break;
    case 3:
      var value = new proto.V1.NullableString;
      reader.readMessage(value,proto.V1.NullableString.deserializeBinaryFromReader);
      msg.setLastName(value);
      break;
    case 4:
      var value = new proto.V1.NullableString;
      reader.readMessage(value,proto.V1.NullableString.deserializeBinaryFromReader);
      msg.setProfilePictureUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.UpdateProfileDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.UpdateProfileDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.UpdateProfileDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.UpdateProfileDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.V1.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getFirstName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.V1.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getLastName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.V1.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getProfilePictureUrl();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.V1.NullableString.serializeBinaryToWriter
    );
  }
};


/**
 * optional NullableString email = 1;
 * @return {?proto.V1.NullableString}
 */
proto.V1.UpdateProfileDto.prototype.getEmail = function() {
  return /** @type{?proto.V1.NullableString} */ (
    jspb.Message.getWrapperField(this, proto.V1.NullableString, 1));
};


/**
 * @param {?proto.V1.NullableString|undefined} value
 * @return {!proto.V1.UpdateProfileDto} returns this
*/
proto.V1.UpdateProfileDto.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.UpdateProfileDto} returns this
 */
proto.V1.UpdateProfileDto.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.UpdateProfileDto.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NullableString first_name = 2;
 * @return {?proto.V1.NullableString}
 */
proto.V1.UpdateProfileDto.prototype.getFirstName = function() {
  return /** @type{?proto.V1.NullableString} */ (
    jspb.Message.getWrapperField(this, proto.V1.NullableString, 2));
};


/**
 * @param {?proto.V1.NullableString|undefined} value
 * @return {!proto.V1.UpdateProfileDto} returns this
*/
proto.V1.UpdateProfileDto.prototype.setFirstName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.UpdateProfileDto} returns this
 */
proto.V1.UpdateProfileDto.prototype.clearFirstName = function() {
  return this.setFirstName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.UpdateProfileDto.prototype.hasFirstName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NullableString last_name = 3;
 * @return {?proto.V1.NullableString}
 */
proto.V1.UpdateProfileDto.prototype.getLastName = function() {
  return /** @type{?proto.V1.NullableString} */ (
    jspb.Message.getWrapperField(this, proto.V1.NullableString, 3));
};


/**
 * @param {?proto.V1.NullableString|undefined} value
 * @return {!proto.V1.UpdateProfileDto} returns this
*/
proto.V1.UpdateProfileDto.prototype.setLastName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.UpdateProfileDto} returns this
 */
proto.V1.UpdateProfileDto.prototype.clearLastName = function() {
  return this.setLastName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.UpdateProfileDto.prototype.hasLastName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NullableString profile_picture_url = 4;
 * @return {?proto.V1.NullableString}
 */
proto.V1.UpdateProfileDto.prototype.getProfilePictureUrl = function() {
  return /** @type{?proto.V1.NullableString} */ (
    jspb.Message.getWrapperField(this, proto.V1.NullableString, 4));
};


/**
 * @param {?proto.V1.NullableString|undefined} value
 * @return {!proto.V1.UpdateProfileDto} returns this
*/
proto.V1.UpdateProfileDto.prototype.setProfilePictureUrl = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.UpdateProfileDto} returns this
 */
proto.V1.UpdateProfileDto.prototype.clearProfilePictureUrl = function() {
  return this.setProfilePictureUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.UpdateProfileDto.prototype.hasProfilePictureUrl = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.V1.SetRolesDto.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.SetRolesDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.SetRolesDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.SetRolesDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.SetRolesDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.SetRolesDto}
 */
proto.V1.SetRolesDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.SetRolesDto;
  return proto.V1.SetRolesDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.SetRolesDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.SetRolesDto}
 */
proto.V1.SetRolesDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.SetRolesDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.SetRolesDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.SetRolesDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.SetRolesDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string loginId = 1;
 * @return {string}
 */
proto.V1.SetRolesDto.prototype.getLoginid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.SetRolesDto} returns this
 */
proto.V1.SetRolesDto.prototype.setLoginid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string roles = 2;
 * @return {!Array<string>}
 */
proto.V1.SetRolesDto.prototype.getRolesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.V1.SetRolesDto} returns this
 */
proto.V1.SetRolesDto.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.V1.SetRolesDto} returns this
 */
proto.V1.SetRolesDto.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.V1.SetRolesDto} returns this
 */
proto.V1.SetRolesDto.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.SendInviteDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.SendInviteDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.SendInviteDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.SendInviteDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    returnurl: (f = msg.getReturnurl()) && proto.V1.NullableString.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.SendInviteDto}
 */
proto.V1.SendInviteDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.SendInviteDto;
  return proto.V1.SendInviteDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.SendInviteDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.SendInviteDto}
 */
proto.V1.SendInviteDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginid(value);
      break;
    case 2:
      var value = new proto.V1.NullableString;
      reader.readMessage(value,proto.V1.NullableString.deserializeBinaryFromReader);
      msg.setReturnurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.SendInviteDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.SendInviteDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.SendInviteDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.SendInviteDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReturnurl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.V1.NullableString.serializeBinaryToWriter
    );
  }
};


/**
 * optional string loginId = 1;
 * @return {string}
 */
proto.V1.SendInviteDto.prototype.getLoginid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.SendInviteDto} returns this
 */
proto.V1.SendInviteDto.prototype.setLoginid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NullableString returnUrl = 2;
 * @return {?proto.V1.NullableString}
 */
proto.V1.SendInviteDto.prototype.getReturnurl = function() {
  return /** @type{?proto.V1.NullableString} */ (
    jspb.Message.getWrapperField(this, proto.V1.NullableString, 2));
};


/**
 * @param {?proto.V1.NullableString|undefined} value
 * @return {!proto.V1.SendInviteDto} returns this
*/
proto.V1.SendInviteDto.prototype.setReturnurl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.SendInviteDto} returns this
 */
proto.V1.SendInviteDto.prototype.clearReturnurl = function() {
  return this.setReturnurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.SendInviteDto.prototype.hasReturnurl = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.V1.BatchSendInviteDto.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.BatchSendInviteDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.BatchSendInviteDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.BatchSendInviteDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.BatchSendInviteDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendinvitedtosList: jspb.Message.toObjectList(msg.getSendinvitedtosList(),
    proto.V1.SendInviteDto.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.BatchSendInviteDto}
 */
proto.V1.BatchSendInviteDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.BatchSendInviteDto;
  return proto.V1.BatchSendInviteDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.BatchSendInviteDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.BatchSendInviteDto}
 */
proto.V1.BatchSendInviteDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.V1.SendInviteDto;
      reader.readMessage(value,proto.V1.SendInviteDto.deserializeBinaryFromReader);
      msg.addSendinvitedtos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.BatchSendInviteDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.BatchSendInviteDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.BatchSendInviteDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.BatchSendInviteDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendinvitedtosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.V1.SendInviteDto.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SendInviteDto sendInviteDtos = 1;
 * @return {!Array<!proto.V1.SendInviteDto>}
 */
proto.V1.BatchSendInviteDto.prototype.getSendinvitedtosList = function() {
  return /** @type{!Array<!proto.V1.SendInviteDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.V1.SendInviteDto, 1));
};


/**
 * @param {!Array<!proto.V1.SendInviteDto>} value
 * @return {!proto.V1.BatchSendInviteDto} returns this
*/
proto.V1.BatchSendInviteDto.prototype.setSendinvitedtosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.V1.SendInviteDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.V1.SendInviteDto}
 */
proto.V1.BatchSendInviteDto.prototype.addSendinvitedtos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.V1.SendInviteDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.V1.BatchSendInviteDto} returns this
 */
proto.V1.BatchSendInviteDto.prototype.clearSendinvitedtosList = function() {
  return this.setSendinvitedtosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.StatusCodeDto.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.StatusCodeDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.StatusCodeDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.StatusCodeDto.toObject = function(includeInstance, msg) {
  var f, obj = {
    statuscode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.StatusCodeDto}
 */
proto.V1.StatusCodeDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.StatusCodeDto;
  return proto.V1.StatusCodeDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.StatusCodeDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.StatusCodeDto}
 */
proto.V1.StatusCodeDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.StatusCodeDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.StatusCodeDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.StatusCodeDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.StatusCodeDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string statusCode = 1;
 * @return {string}
 */
proto.V1.StatusCodeDto.prototype.getStatuscode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.StatusCodeDto} returns this
 */
proto.V1.StatusCodeDto.prototype.setStatuscode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.V1.NullableString.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.V1.NullableString.KindCase = {
  KIND_NOT_SET: 0,
  NULL: 1,
  DATA: 2
};

/**
 * @return {proto.V1.NullableString.KindCase}
 */
proto.V1.NullableString.prototype.getKindCase = function() {
  return /** @type {proto.V1.NullableString.KindCase} */(jspb.Message.computeOneofCase(this, proto.V1.NullableString.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.NullableString.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.NullableString.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.NullableString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.NullableString.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_null: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.NullableString}
 */
proto.V1.NullableString.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.NullableString;
  return proto.V1.NullableString.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.NullableString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.NullableString}
 */
proto.V1.NullableString.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setNull(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.NullableString.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.NullableString.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.NullableString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.NullableString.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.protobuf.NullValue null = 1;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.V1.NullableString.prototype.getNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.V1.NullableString} returns this
 */
proto.V1.NullableString.prototype.setNull = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.V1.NullableString.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.V1.NullableString} returns this
 */
proto.V1.NullableString.prototype.clearNull = function() {
  return jspb.Message.setOneofField(this, 1, proto.V1.NullableString.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.NullableString.prototype.hasNull = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string data = 2;
 * @return {string}
 */
proto.V1.NullableString.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.NullableString} returns this
 */
proto.V1.NullableString.prototype.setData = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.V1.NullableString.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.V1.NullableString} returns this
 */
proto.V1.NullableString.prototype.clearData = function() {
  return jspb.Message.setOneofField(this, 2, proto.V1.NullableString.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.NullableString.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.V1.AuthenticationMethods = {
  NONE: 0,
  PASSWORD: 1,
  MICROSOFT: 2
};

/**
 * @enum {number}
 */
proto.V1.LoginStatus = {
  ACTIVE: 0,
  REVOKED: 1
};

/**
 * @enum {number}
 */
proto.V1.LoginActivationStatus = {
  CREATED: 0,
  INVITED: 1,
  ACTIVATED: 2
};

goog.object.extend(exports, proto.V1);
